import { render, staticRenderFns } from "./Wds.vue?vue&type=template&id=9c8ba156"
import script from "./Wds.vue?vue&type=script&lang=js"
export * from "./Wds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports